/* eslint-disable no-useless-escape */
/* eslint-disable import/no-webpack-loader-syntax */
import React from 'react'
import { Code } from 'rebass'

import Command from '../components/Command'
import Heading from '../components/Heading'
import P from '../components/P'
import SH from '../components/SH'
import Theory from '../components/Theory'
import Tip from '../components/Tip'
import Toc from '../components/Toc'
import ButtonLink from '../components/ButtonLink'

const IndexPage = () => (
  <div>
    <Toc active="encore" />
    <Heading fontSize={7}>Webpack Encore</Heading>
    <Theory>
      <P>Let's talk about Webpack Encore.</P>
    </Theory>
    <Heading fontSize={5}>A Symfony Project</Heading>
    <P>Create a new Symfony Project with:</P>
    <Command>composer create-project symfony/website-skeleton sfreact</Command>
    <P>
      Let's add a first controller in{' '}
      <Code>src/Controller/SecretAgentController.php</Code> with this code:
    </P>
    <SH
      language="PHP"
      code={`
<?php

namespace App\Controller;

use Symfony\Component\HttpFoundation\Response;

class SecretAgentController
{
    public function code()
    {
        return new Response(
            '<html><body>Agent code: 007</body></html>'
        );
    }
}
`}
    />
    <P>Note that we aren't doing anything with JavaScript yet.</P>
    <P>
      Now, activate your route adding this code to
      <Code>config/routes.yml</Code>
    </P>
    <SH
      language="yaml"
      code={`
secret-agent:
    path: /secret-agent
    controller: App\Controller\SecretAgentController::code
    `}
    />
    <Tip>
      Careful, don't add your routes to{' '}
      <Code>config/packages/routing.yaml</Code>. That file contains the
      configuration of the routing package, not the definition of routes.
    </Tip>
    <P>And run the server:</P>
    <Command>php -S 127.0.0.1:8080 -t public</Command>
    <P>
      Open in your browser
      <Code>http://localhost:8080/secret-agent</Code>
      To verify that your Symfony installation is working before adding more
      pieces to it.
    </P>
    <Heading fontSize={5}>Webpack Encore</Heading>
    <P>Let's install Encore and PhpExecJs</P>
    <Command>composer require webpack-encore</Command>
    <Command>composer require nacmartin/phpexecjs</Command>
    <Command>npm install</Command>
    <Command>npm install --save left-pad</Command>
    <P>
      And write an encore config in <Code>webpack.config.ssr.js</Code>
    </P>
    <SH
      language="javascript"
      code={`
var Encore = require("@symfony/webpack-encore");

Encore.setOutputPath("var/webpack/")
  .setPublicPath("/")
  .addEntry("server-bundle", "./assets/js/app.js");

module.exports = Encore.getWebpackConfig();
`}
    />
    <Tip>
      You will see that there is already a <Code>webpack.config.js</Code>{' '}
      already. Don't touch it for now. It makes sense to have two different
      Webpack configurations for the JS code that will be run in your client and
      in your server.
    </Tip>
    <P>
      And place the code we stole to the MI6 unto into{' '}
      <Code>assets/js/app.js</Code>
    </P>
    <SH
      language="javascript"
      code={`
import leftPad from "left-pad";

var sum = (a, b) => a + b;

var makeSecretAgent = code => leftPad(code, 3, 0);

var sumSecretAgent = (a, b) => makeSecretAgent(sum(a, b));

global.sumSecretAgent = sumSecretAgent;
`}
    />
    <P>
      Note that this is not the pipeline version. It would be possible to use
      pipeline in encore, but let's be conservative.
    </P>
    <P>Let's try to generate a SSR bundle with Encore:</P>
    <P>Run:</P>
    <Command>npx encore dev --config webpack.config.ssr.js --watch</Command>
    <P>
      And verify that a file <Code>var/webpack/server-bundle.js</Code> has been
      created.
    </P>
    <P>Let's adapt our controller to use this JS code:</P>
    <SH
      language="PHP"
      code={`
<?php

namespace App\Controller;

use Symfony\Component\HttpFoundation\Response;
use Nacmartin\PhpExecJs\PhpExecJs;

class SecretAgentController
{
    public function code($ssrBundleLocation)
    {

        $phpexecjs = new PhpExecJs();

        $phpexecjs->createContextFromFile($ssrBundleLocation);

        $variant = "sumSecretAgent(3, 4);";

        $result = $phpexecjs->evalJs($variant);

        return new Response(
            '<html><body>Agent code: '.$result.'</body></html>'
        );
    }
}`}
    />
    <P>
      Since we are <i>injecting</i> the parameter{' '}
      <Code>$ssrBundleLocation</Code> we need to define what it means in{' '}
      <Code>config/services.yml</Code>
    </P>
    <SH
      language="yaml"
      code={`
services:
  _defaults:
    #...
    bind:
      $ssrBundleLocation: "%kernel.project_dir%/var/webpack/server-bundle.js"`}
    />

    <P>
      With you we should be ready to open
      <Code>http://localhost:8080/secret-agent</Code>
      and have all the pieces working together.
    </P>
    <ButtonLink to="/react" title="Go to the next section" />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/encore.js